import { Component, EventEmitter, Input, Inject, Output } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';

import { UserTLR } from '../../../humain/user/entities/user-tlr.entity';
import { UserService } from '../../../humain/user/services/user.service';

import { ParcTLR } from '../../parc/entities/parc-tlr.entity';

@Component({
	selector: 'antenne-to-ouvrages-selector',
	templateUrl: 'antenne-to-ouvrages-selector.html',
})
export class AntenneToOuvragesSelectorComponent {
	// Observables pour la combinaison decidant si le champ antenne doit etre active ou non
	private disabledSubject = new Subject<boolean>();
	private expRestrictedSubject = new Subject<boolean>();
	private userRoleSubject = new Subject<string>();

	// Indicateur pour le resultat de la combinaison ci-dessus
	antenneDisabled!: boolean;

	// Indicateur pour la desactivation des champs
	fieldsDisabled: boolean = false;
	
	selectedParc!: ParcTLR | undefined;

	// Valeur actuelle des champs
	antenneId!: number | null;

	// Commandes servant a fixer l'antenne de maniere programative
	resetAntenneIdCommands = new Subject<number | null | undefined>();

	constructor(
		@Inject(UserService) userService: UserService //
	) {
		// Definir l'etat du champ antenne comme la combinaison de l'etat d'activite generale,
		// la volonte de restreindre le choix d'antenne pour les EXP et le role de l'utilisateur connecte
		combineLatest([this.disabledSubject, this.expRestrictedSubject, this.userRoleSubject]).subscribe(
			(valeurs: [boolean, boolean, string]) => {
				let disabled = valeurs[0];
				let expRestricted = valeurs[1];
				let userRole = valeurs[2];
				this.antenneDisabled = disabled || (expRestricted && userRole === "EXP");
			}
		);

		// Veiller a ce que chacun de ces observables ait au moins une valeur par defaut
		this.disabledSubject.next(false);
		this.expRestrictedSubject.next(true);
		userService.getCurrentUserTLR().subscribe(
			(user: UserTLR) => this.userRoleSubject.next(user.role)
		);
	}

	// Parametres de style
	@Input() set disabled(value: boolean) {
		this.fieldsDisabled = value;
		this.disabledSubject.next(value);
	}
	@Input() labelClass: string | undefined;
	@Input() contextFieldClass: string | undefined;
	@Input() ouvrageFieldClass: string | undefined;

	// Indicateur pour le droit des utilisateurs EXP a saisir autre chose que leur antenne
	@Input() set expRestricted(value: boolean) {
		this.expRestrictedSubject.next(value);
	}

	// Evenement de sortie pour l'antenne
	@Output() antenneIdChange = new EventEmitter<number | null>();

	// Two-way binding pour le parc
	_parcId!: number | undefined;
	@Input() set parcId(value: number | undefined) {
		if (this._parcId != value) {
			// Si le parent remet programmativement le parc a zero, alors on demenade la reinitialisation du champ antenne a sa valeur par defaut
			if (!value) {
				this.resetAntenneIdCommands.next(undefined);
			} else {
				console.log('setting parcId: ', value);
			}

			this._parcId = value;
		}
	}
	get parcId(): number | undefined {
		return this._parcId;
	}
	@Output() parcIdChange = new EventEmitter<number | undefined>();

	// Two-way binding poru les ouvrages
	@Input() ouvrageIds: number[] = [];
	@Output() ouvrageIdsChange = new EventEmitter<number[]>();

	////////////////////////////
	// Evenements utilisateur //
	////////////////////////////

	onAntenneIdChange(antenneId: number | null) {
		if (this.antenneId != antenneId) {
			this.antenneId = antenneId;
			this.antenneIdChange.emit(antenneId);

			// Si l'antenne a ete remise a zero, le parc va rester s'il a ete saisi
			// Or le desir de la MOA est que le parc soit alors reinitialise
			if (antenneId === null) {
				this.parcId = undefined;
			}
		}
	}

	onParcSelected(_parc: ParcTLR | undefined) {
		// Quand le parc est manuellement selectionne par l'utilisateur, remettre a zero la selection d'ouvrages
		this.ouvrageIds = [];
		this.ouvrageIdsChange.emit([]);
		this.selectedParc = _parc;

		// NB: Le reste de la gestion du changement est faite par onParcChange 
	}

	onParcChange(parc: ParcTLR | undefined) {
		// NB: Cet evenement peut-etre declenche par l'utilisateur mais aussi par le code quand on fixe la valeur de parcId

		// RG4 : Si le parc est sélectionné alors l'antenne associée au parc est automatiquement complétée
		// Dans tous les cas, quand on modifie le parc, alors l'antenne doit etre mise en coherence avec celui-ci
		if (parc && this.antenneId != parc.antenneId) {
			this.resetAntenneIdCommands.next(parc.antenneId);
		}
	}
}